import { AuthService } from '../services/auth.service';
import { Directive, ElementRef, Renderer2, RendererStyleFlags2, OnInit, Input } from '@angular/core';


@Directive({
  selector: '[appCurrentColor]'
})
export class CurrentcolorDirective implements OnInit {
  @Input() backgroundColor;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private _authService: AuthService
  ) {
  }
  ngOnInit() {
    if (this.backgroundColor) {
      const backgroundColor = this._authService.getDataColor();
      this.renderer.setStyle(
        this.el.nativeElement,
        'background-color',
        backgroundColor,
        RendererStyleFlags2.Important + RendererStyleFlags2.DashCase
      );
      this.renderer.setStyle(
        this.el.nativeElement,
        'color',
        'white',
        RendererStyleFlags2.Important + RendererStyleFlags2.DashCase
      );
    } else {
      const color = this._authService.getDataColor();
      this.renderer.setStyle(
        this.el.nativeElement,
        'color',
        color,
        RendererStyleFlags2.Important + RendererStyleFlags2.DashCase
      );

    }

  }
}
